import {
  AfterViewInit,
  Component,
  HostBinding,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { GridStack } from "gridstack";
import { Widget } from "../widgets";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import { FormGroup } from "@angular/forms";
import { ElementLoaderDirective } from "src/app/ui/element-loader/element-loader.directive";
import { Subject } from "rxjs";

@Component({
  selector: "app-generic-widget",
  templateUrl: "./generic-widget.component.html",
  styleUrls: ["./generic-widget.component.scss"],
})
export class GenericWidgetComponent implements AfterViewInit, OnDestroy {
  faEllipsisH = faEllipsisH;
  @Input() grid!: GridStack;
  @Input() widget!: Widget;
  @Input() draggable!: boolean;
  @Input() filterForm!: FormGroup;
  @Output() onWidgetDelete = new EventEmitter<Widget>();
  @Output() onWidgetOptionsUpdate = new EventEmitter<void>();
  @Output() onResizeWidget = new EventEmitter<void>();
  @Output() onWidgetHeaderMouseDown = new EventEmitter<void>();
  @Output() onWidgetHeaderMouseUp = new EventEmitter<void>();
  @HostBinding("class") classes = "grid-stack-item";
  @ViewChild(ElementLoaderDirective)
  elementLoader!: ElementLoaderDirective;
  onComponentDestroy = new Subject();

  constructor() {}

  get code() {
    return this.widget.code;
  }

  get gridItemID() {
    return `#grid-item-${this.code}`;
  }

  get title() {
    return this.widget.title;
  }

  ngAfterViewInit(): void {
    this.initiateGridWidget();
  }

  initiateGridWidget() {
    this.grid?.makeWidget(this.gridItemID);
  }

  ngOnDestroy(): void {
    this.grid?.removeWidget(this.gridItemID);
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  delete() {
    this.onWidgetDelete.emit(this.widget);
  }

  onMouseDown() {
    this.onWidgetHeaderMouseDown.emit();
  }

  onMouseUp() {
    this.onWidgetHeaderMouseUp.emit();
  }
}
